module.exports = __webpack_public_path__ + "img/icon-past-meet-active.0c92103e.svg";